export const Constants = Object.freeze({
  MAX_FILE_SIZE: (1048576 * 2),
  MAX_TAGS: 50,
  MAX_IMAGES: 10,
});
